<template>
  <div>
    <div v-if="hasPhone">
      Can you confirm if this is your mobile number?
    </div>
    <div v-else>
      Kindly share your mobile number so we can reach out to you when our client chooses to consult with you:
    </div>

    <form @submit.prevent="submit">
      <vue-tel-input
        id="mobile-number"
        v-model.trim="phoneNumber"
        :mode="'national'"
        :auto-format="false"
        :disabled="!phoneCountryCodeLoaded"
        :default-country="phoneCountryCode === null ? '' : parseInt(phoneCountryCode)"
        @country-changed="updateCountryCode"
      />

      <b-form-invalid-feedback
        id="mobile-number-feedback"
        :state="$v.phoneNumber.$dirty ? !$v.phoneNumber.$error : null"
      >
        <div
          v-if="!$v.phoneNumber.required"
          class="text-danger"
        >
          Phone required
        </div>
        <div
          v-if="!$v.phoneNumber.numeric"
          class="text-danger"
        >
          Phone must be in numeric
        </div>
      </b-form-invalid-feedback>
      <b-button
        type="submit"
        class="mt-2"
        :disabled="submitStatus === 'PENDING' || !phoneCountryCodeLoaded"
      >
        <b-spinner
          v-if="phoneCountryCodeLoaded === false"
          small
        />
        <b-spinner
          v-if="submitStatus === 'PENDING'"
          variant="success"
          small
        />
        Confirm
      </b-button>
    </form>
  </div>
</template>

<script>
import { VueTelInput } from 'vue-tel-input'
import { validationMixin } from 'vuelidate'
import { required, numeric } from 'vuelidate/lib/validators'

export default {
  name: 'PhoneConfirmForm',
  components: {
    VueTelInput,
  },
  mixins: [validationMixin],
  validations: {
    phoneNumber: {
      required,
      numeric,
    },
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
    redirect: {
      type: String,
      required: true,
    },
    confirmUrl: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      phoneCountryCodeLoaded: false,
      phoneCountryCode: this.user.mobile_phone_code,
      phoneNumber: this.user.mobile_phone,
      submitStatus: null,
    }
  },
  computed: {
    hasPhone () {
      return this.user.mobile_phone !== null && this.user.mobile_phone !== ''
    },
  },
  methods: {
    updateCountryCode (countryObject) {
        if(countryObject) {
            this.phoneCountryCodeLoaded = true
        }

      this.phoneCountryCode = countryObject.dialCode
    },
    async submit () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.submitStatus = 'ERROR'
      } else {
        this.submitStatus = 'PENDING'

        try {
          const result = (await axios.post(this.confirmUrl,
              { phoneCountryCode: this.phoneCountryCode, phone: this.phoneNumber, userId: this.user.id })).data

          alert(result.success.message)
        } catch (error) {
          alert(error.response.data.errors.message)
        } finally {
          this.submitStatus = null
        }

        window.location.href = this.redirect
      }
    },
  },
}

</script>
<style src="vue-tel-input/dist/vue-tel-input.css"></style>
<style scoped>

</style>
